import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import { TbGalaxy } from "react-icons/tb";
import { FcGoogle } from "react-icons/fc";
import { SiGithub } from "react-icons/si";
import GoogleLogin from "./GoogleLogin";

function Login() {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [showPassword, setShowPassword] = useState(false);
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [rememberChecked, setRememberChecked] = useState(false)


    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            startLogin();
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    function startLogin() {
        setErr({ message: "", display: false })
        const email_reg = document.getElementById("email_reg");
        const password_reg = document.getElementById("password_reg");

        let error = false;
        let error_email = false;
        let error_password = false;

        if (email_reg.value === "") {
            error = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else if (!validateEmail(email_reg.value)) {
            error = true;
            error_email = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else {
            email_reg.style.border = "";
        }

        if (password_reg.value === "") {
            error = true;
            password_reg.style.border = "1px solid var(--danger)";
        } else {
            password_reg.style.border = "";
        }

        if (error) {
            if (error_email) {
                setErr({ message: t.register_form.email_format, display: true });
            } else if (error_password) {
                setErr({ message: t.register_form.password_err, display: true });
            } else {
                setErr({ message: t.register_form.red_fields, display: true });
            }
        } else {
            loginUser(email_reg.value, password_reg.value);
            setErr({ message: "", display: false });
        }
    }

    function loginUser(email, password) {
        setLoading(true);
        const dataToSend = {
            email: email,
            password: password,
        };

        fetch('https://backend.erioon.com/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if (data.message === "OK") {
                    const user_id = data.user_id;
                    if (rememberChecked) {
                        document.cookie = `erioon=${user_id}; path=/; max-age=` + (7 * 24 * 60 * 60);
                    }
                    sessionStorage.setItem("user_id", user_id);
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                    if (isMobile) {
                        navigate("/mobile_device");
                    } else {
                        navigate("/control_panel/projects");
                    }
                } else if (data.message === "Invalid_email_or_password") {
                    setErr({ message: t.register_form.invalid_email_pass, display: true });
                } else if (data.message === "email_not_valid") {
                    setErr({ message: t.register_form.email_format, display: true });
                } else if (data.message === "account_not_exists") {
                    setErr({ message: "Account does not exist. Please register first.", display: true });
                } else if (data.error) {
                    setErr({ message: t.register_form.errors_back, display: true });
                }
            })
            .catch(error => {
                setLoading(false);
                console.error(error);
                setErr({ message: t.register_form.problem_back, display: true });
            });
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };



    return (
        <div className="main_frame">
            <div className="register_page">
                <div className="register_container_reg">

                    <div className="register_conts_reg reg_cont_first">

                        <div className="reg_cont">
                            <p className="title_form" onClick={() => navigate("/")}><span className="ia_span"><i><TbGalaxy /></i></span>Erioon</p>
                            <input type="text" id="email_reg" placeholder="Email" className="register_form_first" />
                            <div className="password_eye">
                                <input type={showPassword ? "text" : "password"} id="password_reg" placeholder="Password" className="register_form_first" />
                                <button className="show_passowrd" onClick={togglePasswordVisibility}>
                                    <i className={`fa-regular fa-eye${showPassword ? "" : "-slash"}`}></i>
                                </button>
                            </div>
                            <div className="priv_mail_cont">
                                <input type="checkbox" checked={rememberChecked} onChange={() => setRememberChecked(!rememberChecked)} />
                                <p id="privacy_policy_desc">Remember me on this device</p>
                            </div>

                            <button onClick={startLogin} className="start_btn">
                                {loading ? (
                                    <Spinner loading={loading} />
                                ) : (
                                    <>
                                        {t.register_form.button_login}
                                    </>
                                )
                                }
                            </button>
                            <ErrorMessage err={err} />
                            <div className="reg_auth_ext_cont">
                                <GoogleLogin type_enter={"Login"} />

                                {/* <button className="reg_auth_ext_btn"><i><SiGithub /></i> GitHub</button> */}
                            </div>
                            {/* <p className="already_present">Forgot password? <span onClick={() => navigate("/reset-password")}> Reset password</span></p> */}
                            <p className="already_present">{t.register_form.dont_have_account} <span onClick={() => navigate("/register")}> {t.register_form.go_register}</span></p>
                        </div>
                    </div>
                </div>
                <div className="register_conts_reg">
                    <div className="reg_intro_cont">
                        <p className="title_login">{t.register_form.welcome_back}</p>
                        <p className="description_login">{t.register_form.update_mex}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
